import { render } from "./TabPickPoints.vue?vue&type=template&id=0a752838&scoped=true"
import script from "./TabPickPoints.vue?vue&type=script&lang=js"
export * from "./TabPickPoints.vue?vue&type=script&lang=js"

import "./TabPickPoints.vue?vue&type=style&index=0&id=0a752838&scoped=true&lang=css"

import exportComponent from "C:\\Users\\MORIMI\\Documents\\git_repositories\\heightlimit_mapbox\\heightlimit_mapbox\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a752838"]])

export default __exports__